import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export class Showcase extends Vue {

    public slug: string = '';

    created(){
        this.slug = this.$route.params.slug;
    }

}